import { useCallback, type RefObject } from 'react';

/**
 * Use this hook to set input value and preserve undo/redo history stack.
 * Keep in mind that cursor will be moved to the end of the input.
 */
export function useInputWithHistoryStack(
  textareaRef: RefObject<HTMLTextAreaElement>,
  inputChangeCallback?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void,
) {
  return useCallback(
    (input: string) => {
      const textarea = textareaRef?.current;

      if (!textarea) {
        return;
      }

      if (input === '') {
        textarea.value = input;

        inputChangeCallback?.({ target: textarea } as React.ChangeEvent<HTMLTextAreaElement>);

        return;
      }

      textarea.focus();
      textarea.select();

      document.execCommand('insertText', false, input);

      inputChangeCallback?.({ target: textarea } as React.ChangeEvent<HTMLTextAreaElement>);

      textarea.selectionStart = input.length;
      textarea.selectionEnd = input.length;
    },
    [inputChangeCallback],
  );
}
